import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { ErrorPopup } from "../../../../ui/organisms/errorPopup"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { RightBar } from "../../../../ui/organisms/rightBar"
import { SuccessPopup } from "../../../../ui/organisms/successPopup"
import { CustomerInfoDTO } from "../dataService/dto"
import { DepartureProtocolValidation, GetDepartureProtocolById, resetDepartureProtocolUpdateStatus } from "../slice"
import { EditDepartureLeft } from "./editDepartureLeft"
import { EditDepartureRight } from "./editDepartureRight"

interface ProtocolData {
    protocol: string
    sender: string
    region: string
    object: string
    operator: CustomerInfoDTO[]
}


export function EditDepartureProtocol() {
    const navigate = useNavigate()
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [successData, setSuccessData] = useState<ProtocolData | null>(null)
    const dispatch = useAppDispatch()
    const departureProtocolState = useAppSelector(state => state.departureProtocol)

    useEffect(() => {
        if (departureProtocolState.departureProtocolUpdateStatus === 'successfully') {
            // dispatch(resetPPFileAndAtt())
            dispatch(GetDepartureProtocolById(departureProtocolState.departureProtocolIdToUpdate))
        }
    }, [departureProtocolState.departureProtocolUpdateStatus])

    useEffect(() => {
        if (departureProtocolState.getDepartureProtocolByIdStatus === 'successfully' &&
            departureProtocolState.getDepartureProtocolByIdResponse !== undefined
        ) {
            const data = departureProtocolState.getDepartureProtocolByIdResponse
            const newData: ProtocolData = {
                protocol: `${data.headQuarter} P${data.protocolNumber}`,
                sender: data.receiver,
                region: data.region,
                operator: data.customersInfo!,
                object: `${data.departureObject.description} [${data.departureObject.coding}]`,
            }
            setSuccessData(newData)
            setShowSuccess(true)
        }
    }, [departureProtocolState.getDepartureProtocolByIdStatus])

    return (
        <Layout
            menuItem={MenuItems.PROTOCOLLO}
            breadcrumbItems={['Gestione Protocollo', 'Partenza']}
            noPaddingLat
            headerLabel="Protocollo Partenza"
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/departureProtocol')} color={colors.white} />
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end gap-2">
                    <ButtonComponent
                        variant='solid'
                        color='orange'
                        size='sm'
                        iconPosition='off'
                        label='Salva protocollo'
                        onClick={() => { dispatch(DepartureProtocolValidation(departureProtocolState.departureProtocolUpdateRequest)) }}
                        disabled={
                            departureProtocolState.departureProtocolUpdateStatus === 'loading' ||
                            !departureProtocolState.departureProtocolUpdateRequest.headQuarter ||
                            !departureProtocolState.departureProtocolUpdateRequest.protocolDate ||
                            !departureProtocolState.departureProtocolUpdateRequest.receiver ||
                            !departureProtocolState.departureProtocolUpdateRequest.departureObjectId
                        }
                    />
                </div>
            }
        >
            <div className="bg-brandPrimary-100" style={{ display: 'flex', height: '100%' }}>
                <div className="w-[100%] flex flex-col gap-[16px] filter bg-brandPrimary-200" style={{ flex: 0.7, padding: '24px 24px 24px 24px', borderTopRightRadius: '20px' }}>
                    <SuccessPopup
                        message="Dati salvati correttamente."
                        active={departureProtocolState.departureProtocolUpdateStatus === 'successfully'}
                        onClose={() => dispatch(resetDepartureProtocolUpdateStatus())}
                    />
                    <ErrorPopup
                        message="Errore durante il salvataggio dei dati."
                        active={departureProtocolState.departureProtocolUpdateStatus === 'failed'}
                        onClose={() => dispatch(resetDepartureProtocolUpdateStatus())}
                    />
                    <EditDepartureLeft />
                </div>
                <div className="bg-brandPrimary-100" style={{ flex: 0.3 }}>
                    <RightBar>
                        <EditDepartureRight />
                    </RightBar>
                </div>
            </div>
        </Layout>
    )
}